
import { Component, Vue, Prop } from 'vue-property-decorator';
import { centsToEuro, currency } from '@/filters/currency';
import Fieldset from '@/components/_common/Fieldset.vue';
import { SellOffer } from '@/store/trading/types';
import { Asset } from '@/store/trading/types';

@Component({
  name: 'sell-offer-details',
  components: {
    Fieldset,
  },
  filters: {
    centsToEuro,
    currency,
  },
})
export default class SellOfferDetails extends Vue {
  @Prop({ required: true })
  sellOffer: SellOffer;

  @Prop({ required: true })
  project: Asset;
}
